import { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    useEffect(() => {
      document.title = 'Jubilee';
    }, []),
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Jubilee
        </p>
      </header>
    </div>
  );
}

export default App;
